var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-change-phone" },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "changePhoneForm",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-position": "left",
          },
        },
        [
          _c("p", [
            _vm._v(
              "Below is the question you selected during registration, please provide the answer you gave during registration."
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.userQuestion,
                "inline-message": true,
                prop: "answer",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  size: "medium",
                  placeholder: "Please answer your security question",
                },
                model: {
                  value: _vm.form.answer,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "answer", $$v)
                  },
                  expression: "form.answer",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "Your date of birth",
                "inline-message": true,
                prop: "dob",
              },
            },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "date",
                  placeholder: "DATE OF BIRTH (DD/MM/YYYY)",
                  format: "dd/MM/yyyy",
                  "value-format": "MM/dd/yyyy",
                  size: "medium",
                },
                model: {
                  value: _vm.form.dob,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "dob", $$v)
                  },
                  expression: "form.dob",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "new-phone",
              attrs: {
                label:
                  "Enter your new mobile number (we will send a code to this number when you press continue).",
                "inline-message": true,
                prop: "phone",
              },
            },
            [
              _c("el-input", {
                attrs: { size: "medium", placeholder: "e.g. 0412345678" },
                model: {
                  value: _vm.form.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "phone", $$v)
                  },
                  expression: "form.phone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "text-muted" }, [
            _vm._v("Please note this will update your member record."),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.error
        ? _c("el-alert", {
            attrs: {
              title: "Authentication failed",
              type: "error",
              description: _vm.error,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-action" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-confirm",
              attrs: { type: "primary", disabled: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.submitForm("changePhoneForm")
                },
              },
            },
            [_vm._v("Continue")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "text" }, on: { click: _vm.cancelLogIn } },
            [_vm._v("Cancel and return to login")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }